export enum ClinicalPatientTypeEnum {
    Patient = 1,
    ConvoyPatient = 2,
    HIVPatient = 3,
    PEPPatient = 4
}